import React, { useState } from "react";
import "../../../App.css";
import HeroSection from "./HeroSection";
import FeaturePanels from "./FeaturePanels";
import TestimonialSlider from "./TestimonialSlider";
import Cookies from "js-cookie";

function Home() {
  const [showPromotion, setShowPromotion] = useState(
    !Cookies.get("hide-promo")
  );

  function closePromotion(e) {
    e.preventDefault();

    setShowPromotion(false);

    Cookies.set("hide-promo", true, { expires: 14 });
  }

  return (
    <>
      <HeroSection />
      <TestimonialSlider />
      <FeaturePanels />
    </>
  );
}

export default Home;
